import { render, staticRenderFns } from "./knowledge-type.vue?vue&type=template&id=49fc5f25&scoped=true"
import script from "./knowledge-type.vue?vue&type=script&lang=js"
export * from "./knowledge-type.vue?vue&type=script&lang=js"
import style0 from "./knowledge-type.vue?vue&type=style&index=0&id=49fc5f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc5f25",
  null
  
)

export default component.exports